/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

// export type QuestionType = 'Scale' | 'Choice' | 'Text';
// export type QuestionMetric = 'CSAT' | 'CES' | 'FCR' | 'NPS' | 'CXJ';
//
// export type TitleSize = 'large' | 'small';
// export type OpenQuestionSkin = 'SingleLine' | 'MultiLine';
// export type ChoiceQuestionSkin = 'List' | 'Dropdown';
// export type SentimentQuestionSkin = 'Binary' | 'YesNo';
// export type ScaleQuestionSkinType =
//   | 'Stars'
//   | 'StarsSingle'
//   | 'Emoticons'
//   | 'NumbersGradient'
//   | 'Numbers'
//   | 'YesNo'
//   | 'Slider'
//   | 'RadioButtons'
//   | 'Boxes'
//   | 'BoxesGradient';
// export type QuestionSkin =
//   | OpenQuestionSkin
//   | SentimentQuestionSkin
//   | ChoiceQuestionSkin
//   | ScaleQuestionSkinType;

import { Choice } from './flow';

export interface Questionnaire {
  id: string;
  organizationId?: string;
  name?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface QuestionnaireQuestion {
  id: string;
  questionId: string;
  questionnaireId: string;
  sorting: number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
}

export interface QuestionDetail {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  activeFrom: Date;
  inactiveFrom: Date;
  number: number;
  organizationUnitId: string;
  groupUnit: string;
  targetUnit: string;
  title?: string;
  description?: string;
  scale: string;
  type: string;
  maxChoiceCount: number;
  public: boolean;
  active: boolean;
  isDraft: boolean;
  background?: {
    id: number;
    url?: string;
  };
  imageUrl?: string;
  image?: string;
  sorting: number;
  onlyLogged: boolean;
  // links: { rel: string; url: string }[]; // todo remove?
  choices?: Choice[];
  shared: boolean;
}

export interface QuestionLastAccess {
  id: number;
  userIdentifier: string;
  createdAt: Date;
  questionId: number;
}

export interface QuestionStats {
  id: number;
  type: string;
  questionId: number;
  date?: Date;
  source?: string;
  value: number;
  updatedAt: Date;
  createdAt: Date;
}

// export type ExtraParams = {
//   titleSize?: TitleSize;
//   limit?: number;
//   shuffle?: boolean;
//   minChoiceLimit?: number;
//   maxChoiceLimit?: number;
//   reverseButtonOrder?: boolean;
// };

export const questionObjExtraParams = [
  'titleSize',
  'limit',
  'shuffle',
  'pinLastOption',
  'minChoiceLimit',
  'maxChoiceLimit',
  'reverseButtonOrder',
];
